/* @flow */
import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { closeMenu } from 'redux/modules/main-menu/index';
import { Authenticated, NotAuthenticated, LogoutLink } from 'interactive-solutions/authentication';
import Translate from 'react-translate-component';
import LocalePicker from 'components/header/locale-picker/locale-picker';
import CountryPicker from 'components/header/country-picker/country-picker';
import * as variables from 'frilans-finans/variables';

export class MainMenu extends React.Component {

  static propTypes = {
    user: PropTypes.object.isRequired,
    closeMenu: PropTypes.func.isRequired,
    selectedLocale: PropTypes.string.isRequired,
    selectedCountry: PropTypes.string.isRequired,
    availableLocales: PropTypes.array.isRequired,
    availableCountries: PropTypes.array.isRequired
  };

  renderSwedishMenu () {
    if (this.props.selectedLocale === 'se') {
      return (
        <div>
          <p className="menu-name"><Translate content='HEADER_MENU_SERVICES'/></p>
          <ul className="menu-list">
            <li>
              <a href={variables.frontUrl + '/fakturaverktyg/'}>
                <Translate content='INVOICE_TOOL_LINK_TEXT'/>
              </a>
            </li>
            <li>
              <a href={variables.frontUrl + '/evenemang-och-inspiration/'}>
                <Translate content='EVENTS_AND_INSPIRATION_LINK_TEXT'/>
              </a>
            </li>
            <li>
              <a href={variables.frontUrl + '/network/'}>
                <Translate content='NETWORK_LINK_TEXT'/>
              </a>
            </li>
            <li>
              <a href={variables.frontUrl + '/vara-forsakringar/'}>
                <Translate content='INSURANCES'/>
              </a>
            </li>
            <li>
              <a href={variables.frontUrl + '/jobba-internationellt/'}>
                <Translate content='WORK_INTERNATIONALLY_LINK_TEXT'/>
              </a>
            </li>
          </ul>
          <p className="menu-name"><Translate content='HEADER_MENU_HELP'/></p>
          <ul className="menu-list">
            <li>
              <a href={variables.frontUrl + '/sa-har-fungerar-det/'}>
                <Translate content='HOW_IT_WORKS'/>
              </a>
            </li>
            <li>
              <a href={variables.frontUrl + '/fragor-och-svar/'}>
                <Translate content='QUESTIONS_AND_ANSWERS'/>
              </a>
            </li>
            <li>
              <a href={variables.frontUrl + '/traffa-vara-egenanstallda/'}>
                <Translate content='MEET_OUR_UMBRELLA_CONTRACTORS'/>
              </a>
            </li>
            <li>
              <a href={variables.frontUrl + '/egenanstallning/'}><Translate content='THIS_IS_SELF_EMPLOYMENT'/></a>
            </li>
            <li>
              <a href={variables.frontUrl + '/arbetsmiljo/'}><Translate content='GOOD_WORKING_CONDITIONS'/></a>
            </li>
          </ul>
          <p className="menu-name"><Translate content='HEADER_MENU_ABOUT'/></p>
          <ul className="menu-list">
            <li>
              <a href={variables.frontUrl + '/om-frilans-finans/'}>
                <Translate content='ABOUT_FRILANS_FINANS'/>
              </a>
            </li>
            <li>
              <a href={variables.frontUrl + '/kontakta-oss/'}>
                <Translate content='CONTACT_US'/>
              </a>
            </li>
            <li>
              <a href={variables.frontUrl + '/nyheter-och-press/'}>
                <Translate content='NEWS_AND_PRESS'/>
              </a>
            </li>
          </ul>
          <p className="menu-name"><Translate content='SOCIAL_MEDIA'/></p>
          <ul className="menu-list">
            <li>
              <a href="https://www.facebook.com/FrilansFinans/" target="_blank">Facebook</a>
            </li>
            <li>
              <a href="https://twitter.com/frilansfinans" target="_blank">Twitter</a>
            </li>
            <li>
              <a href="https://www.linkedin.com/company/frilans-finans-sverige-ab" target="_blank">LinkedIn</a>
            </li>
            <li>
              <a href="https://www.instagram.com/frilansfinans/" target="_blank">Instagram</a>
            </li>
          </ul>
        </div>
      );
    }
  }

  renderEnglishMenu () {
    if (this.props.selectedLocale === 'en') {
      return (
        <div>
          <p className="menu-name"><Translate content='HEADER_MENU_SERVICES'/></p>
          <ul className="menu-list">
            <li>
              <a href={variables.frontUrl + '/testaattskickafaktura/'}>
                <Translate content='INVOICE_TOOL'/>
              </a>
            </li>
            <li>
              <a href={variables.frontUrl + '/en/network/'}>
                <Translate content='NETWORK'/>
              </a>
            </li>
            <li>
              <a href={variables.frontUrl + '/en/vara-forsakringar/'}>
                <Translate content='INSURANCES'/>
              </a>
            </li>
          </ul>
          <p className="menu-name"><Translate content='HEADER_MENU_HELP'/></p>
          <ul className="menu-list">
            <li>
              <a href={variables.frontUrl + '/en/sa-har-fungerar-det/'}>
                <Translate content='HOW_IT_WORKS'/>
              </a>
            </li>
            <li>
              <a href={variables.frontUrl + '/en/questions-and-answers/'}>
                <Translate content='QUESTIONS_AND_ANSWERS'/>
              </a>
            </li>
            <li>
              <a href={variables.frontUrl + '/en/meet-our-umbrella-contractors/'}>
                <Translate content='MEET_OUR_UMBRELLA_CONTRACTORS'/>
              </a>
            </li>
          </ul>
          <p className="menu-name"><Translate content='HEADER_MENU_ABOUT'/></p>
          <ul className="menu-list">
            <li>
              <a href={variables.frontUrl + '/en/om-frilans-finans/'}>
                <Translate content='ABOUT_FRILANS_FINANS'/>
              </a>
            </li>
            <li>
              <a href={variables.frontUrl + '/en/contact-us/'}>
                <Translate content='CONTACT_US'/>
              </a>
            </li>
            <li>
              <a href={variables.frontUrl + '/en/nyheter-och-press/'}>
                <Translate content='NEWS_AND_PRESS'/>
              </a>
            </li>
          </ul>
          <p className="menu-name"><Translate content='SOCIAL_MEDIA'/></p>
          <ul className="menu-list">
            <li>
              <a href="https://www.facebook.com/FrilansFinans/" target="_blank">Facebook</a>
            </li>
            <li>
              <a href="https://twitter.com/frilansfinans" target="_blank">Twitter</a>
            </li>
            <li>
              <a href="https://www.linkedin.com/company/frilans-finans-sverige-ab" target="_blank">LinkedIn</a>
            </li>
            <li>
              <a href="https://www.instagram.com/frilansfinans/" target="_blank">Instagram</a>
            </li>
          </ul>
        </div>
      );
    }
  }

  render () {
    return (
      <div className='top-menu-wrapper'>

        <div className='hide-until-tablet mobile-top-menu'>
          <NotAuthenticated>
            <Link to='/login' onClick={this.props.closeMenu} className='btn white'><Translate content='LOGIN'/></Link>
            <Link to='/register' onClick={this.props.closeMenu} className='btn outlined'>
              <Translate content='CREATE_ACCOUNT'/>
            </Link>
          </NotAuthenticated>
          <Authenticated>
            <div onClick={this.props.closeMenu}>
              <Link to='/invoice-tool' className='btn white'><Translate content='CREATE_INVOICE'/></Link>
              <LogoutLink classes='btn outlined'><Translate content='LOGOUT'/></LogoutLink>
            </div>
          </Authenticated>
        </div>

        <NotAuthenticated>
          {this.renderEnglishMenu()}
          {this.renderSwedishMenu()}
        </NotAuthenticated>

        <Authenticated>
          <p className='menu-name'><Translate content='MY_PAGES'/></p>
          <ul className='menu-list' onClick={this.props.closeMenu}>
            <li><Link to='/activities'><Translate content='ACTIVITIES'/></Link></li>
            <li><Link to='/economy'><Translate content='MENU_MY_INVOICING'/></Link></li>
            <li><Link to='/insurances'><Translate content='INSURANCES'/></Link></li>
            <li><Link to='/customers'><Translate content='MY_CUSTOMERS'/></Link></li>
            <li><Link to='/settings'><Translate content='SETTINGS'/></Link></li>
            <li><Link to='/faq'><Translate content='FAQ'/></Link></li>
            <li><LogoutLink><Translate content='LOGOUT'/></LogoutLink></li>
          </ul>
        </Authenticated>

        <div className='hide-until-tablet mobile-bottom-menus'>
          <CountryPicker countries={this.props.availableCountries} selectedCountry={this.props.selectedCountry}/>
          <LocalePicker locales={this.props.availableLocales} selectedLocale={this.props.selectedLocale}/>
        </div>
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
    user: state.user,
    selectedLocale: state.i18n.locale,
    selectedCountry: state.i18n.country,
    availableLocales: state.i18n.availableLocales,
    availableCountries: state.i18n.availableCountries
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeMenu: () => dispatch(closeMenu())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainMenu);



/** WEBPACK FOOTER **
 ** ./src/components/header/main-menu/main-menu.js
 **/